export class IGetSurveys{
  id: number = 0;
  state: string = "";
  name: string = "";
  description: string = "";
  url: string = "";
  user: string = "";
  createdAt?: string = "";
  updatedAt?: string = "";
}